import type {RouteRecordRaw} from 'vue-router';
import {createPropositionGuard} from '@myparcel-frontend/proposition';
import useAccount from '@/composables/useAccount/useAccount';

export const fulfilmentRoutes: RouteRecordRaw[] = [
  {
    name: 'fulfilment.request',
    path: '/fulfilment/request',
    component: () => import('@/views/Fulfilment/Request/Request.vue'),
    meta: {
      title: (t) => t('settings.shop.orders.fulfilment.title'),
    },
    beforeEnter: [
      createPropositionGuard((proposition) => proposition.enableFulfilment, {
        redirect: {name: 'dashboard'},
        path: '/dashboard',
      }),
      () => {
        const {accountSettings} = useAccount();

        if (accountSettings.value.fulfilment) {
          return {name: 'dashboard'};
        }

        return true;
      },
    ],
  },
];
